<!--suppress ES6ShorthandObjectProperty -->
<template>
  <div class="row" id="VerVideo">
    <div class="col-12" v-show="show_v">
      <b-button @click="volver"> Volver </b-button>
      <br>
      <br>
    </div>
    <div
      :class="(!show_v)?'col-8':'col-12'"
    >
      <b-table
        v-if="!show_v"
        style="font-size: 9px;overflow: auto; max-height: 900px; "
        class="customTable"
        thead-class="custom-fix"
        responsive
        :small="true"
        :items="items"
        :bordered="true"
        hover
        :fields="fields"
      >
        <b-button slot="video" slot-scope="data" @click="showVideo(data.value)"><span class="ti-eye"></span></b-button>
      </b-table>
      <Videodata :falla="falla_v" :show="show_v"></Videodata>
    </div>
    <div class="col-4" v-show="!show_v">
      <b-card
        title="Filtro De Video"
        sub-title="aplicar algun filtro para ver resultado"
      >
        <b-card-body>
          <span class="ti-search float-right"></span>
          <b-form @submit.prevent="filter" v-show="show">
            <b-form-group
              id="filter1"
              label="Subcuenca"
              label-for="input1"
              description="ID De La Subcuenca"
            >
              <b-form-input
                id="input1"
                type="text"
                v-model="filt.subcuenca"
                placeholder="SC"
              />
            </b-form-group>
            <b-form-group
              id="filter5"
              label="Contato"
              label-for="input5"
              description="ID Del Contrato"
            >
              <b-form-input
                id="input5"
                type="text"
                v-model="filt.contrato"
                placeholder="Contrato"
              />
            </b-form-group>
            <b-form-group
              id="filter2"
              label="ID Tramo"
              label-for="input2"
              description="ID Del Tramo"
            >
              <b-form-input
                id="input2"
                v-model="filt.tramo"
                type="text"
                placeholder="Identifica"
              />
            </b-form-group>
            <b-form-group
              id="filter3"
              label="Fecha Inicial"
              label-for="input2"
              description="las fechas son incluyentes"
            >
              <b-form-input id="input3" v-model="filt.fechaIn" type="date" />
            </b-form-group>
            <b-form-group
              id="filter4"
              label="Fecha Final"
              label-for="input4"
              description="las fechas son incluyentes"
            >
              <b-form-input id="input4" v-model="filt.fechaFn" type="date" />
            </b-form-group>

            <b-button type="submit" variant="primary">Filtrar</b-button>
            <b-button
              class="float-right"
              @click="reset"
              type="reset"
              variant="danger"
              >Limpiar</b-button
            >
          </b-form>
        </b-card-body>
      </b-card>
    </div>
{{filt.fechaIn}}
  </div>
</template>

<script>
/* eslint-disable no-console */
import Http from "../Http";
import Videodata from "./videodata";

export default {
  name: "VisualizarVideo",
  components: {Videodata},
  computed: {
    items() {
      return this.fallas.map(x => ({
        video: x.video_id,
        Contrato: x.reporte_contrato,
        EP: x.reporte_estadoPago,
        Zona: x.reporte_zona,
        Fecha_de_Ejecucion_ITV: new Date(
          x.video.video_fechacreacion
        ).toLocaleDateString(),
        Localidad: x.reporte_localidad,
        Sub_Cuenca: x.video.video_subcuenca,
        Identifica: x.video.video_tramo,
        CI_Inicial: x.reporte_ciInicial,
        CI_Final: x.reporte_ciFinal,
        Direccion: x.reporte_direccion,
        Desde: x.reporte_desde,
        Hasta: x.reporte_hasta,
        Longitud_Tramo: x.reporte_largototal,
        Longitud_Inspeccion: x.reporte_largoinpec,
        Sentido_Grabacion: x.reporte_gravedad,
        Diametro_Tramo: x.reporte_diametro,
        Material: x.reporte_material,
        Falla_Detectada: x.anomalia.anomalia_nombre,
        Ubicacion_De_Falla: x.reporte_lfalla,
        Gravedad_Falla: x.reporte_gravedad,
        Propuesta_De_Solucion: x.solucion.solucion_nombre,
        Observaciones: x.reporte_observacion
      }));
    }
  },
  data: () => ({
    show: true,
    fields: [
      {
        key: "video",
        label: "ver video"
      },
      "Contrato",
      "EP",
      "Zona",
      {
        key: "Fecha_de_Ejecucion_ITV",
        label: "Fecha de Ejecución ITV",
        sortable: true
      },
      "Localidad",
      "Sub_Cuenca",
      "Identifica",
      "CI_Inicial",
      "CI_Final",
      "Direccion",
      "Desde",
      "Hasta",
      "Longitud_Tramo",
      "Longitud_Inspeccion",
      "Sentido_Grabacion",
      "Diametro_Tramo",
      "Material",
      "Falla_Detectada",
      "Ubicacion_De_Falla",
      "Gravedad_Falla",
      "Propuesta_De_Solución",
      "Observaciones"
    ],
    filt: {
      subcuenca: null,
      tramo: null,
      fechaIn: null,
      fechaFn: null,
      contrato: null
    },
    fallas: [],
    show_v: false,
    falla_v: null
  }),
  methods: {
    showVideo(video){
      let v = this.fallas.find(x => x.video_id === video);
      this.falla_v = v;
      this.show_v = true;
    },
    reset() {
      this.show = false;
      this.filt = {
        subcuenca: null,
        tramo: null,
        fechaIn: null,
        fechaFn: null,
        contrato: null
      };
      this.$nextTick(() => {
        this.show = true;
      });
    },
    filter: function() {
      let subcuenca = this.filt.subcuenca;
      let contrato = this.filt.contrato;
      let tramo = this.filt.tramo;
      let fechain = this.filt.fechaIn;
      let fechafn = this.filt.fechaFn;
      if (subcuenca == null || subcuenca.trim()==="") {
        subcuenca = "na";
      }
      if (contrato == null || contrato.trim()==="") {
        contrato = "na";
      }
      if (tramo == null || tramo.trim()==="") {
        tramo = "na";
      }
      if (fechain == null|| fechain.trim()==="") {
        fechain = "na";
      }
      if (fechafn == null || fechafn.trim()==="") {
        fechafn = "na";
      }
      Http.Http()
        .get(
          `Reporte/web/${subcuenca}/${contrato}/${tramo}/${fechain}/${fechafn}`
        )
        .then(resp => {
          console.log(resp);
          this.fallas = resp.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    volver(){
      this.show_v = false;
      this.falla_v = null;
    }
  }
};
</script>

<style>
  .customTable thead{
    /*el thead va ser siempre estatico**/
    background-color: white;
  }
  .custom-fix{
    background-color: #0d6b42!important;
    color: white;
  }
  .table-scroll{

  }
</style>
